/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Sku_TakenInputs */

const vi_packaging_material_sku_taken = /** @type {(inputs: Packaging_Material_Sku_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã SKU đã tồn tại. Vui lòng chọn mã khác.`)
};

/**

* @param {Packaging_Material_Sku_TakenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_sku_taken = /** @type {((inputs?: Packaging_Material_Sku_TakenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Sku_TakenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_sku_taken(inputs)
});